<template>
  <div v-if="item" class="grid gap-2.5 pl-2 pr-3 pb-3 break-words">
    <div class="flex justify-between items-start border-b pb-2.5">
      <div>
        <h6 class="text-[20px] font-medium font-poppins text-customYellow-100 mb-2.5">
          Plan Amount
        </h6>
        <h4 class="mb-0 text-[30px] font-semibold font-poppins text-black-100">
          ${{ $helper.formatAmount(item.total_amount) }}<span class="text-[20px]">/{{
            item.payment_term_slug === 'yearly' ? 'yr' : 'mo'
          }}</span>
        </h4>
      </div>
      <div class="flex items-center gap-2.5">
        <p v-if="item.status_slug == 'pending'"
          class="inline-block text-center py-[1px] px-[10px] text-sm rounded-[5px] mb-0 text-white bg-[#F39C12]">
          {{ item.status_text }}</p>
        <p v-else-if="item.status_slug == 'approved'"
          class="inline-block text-center py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#65B741]">
          {{ item.status_text }}</p>
        <p v-else-if="item.status_slug == 'payment_failed'|| item.status_slug == 'suspended'"
          class="inline-block text-center py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#FE5000]">
          {{ item.status_text }}</p>
        <p v-else-if="item.status_slug == 'rejected'"
          class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#FE5000]">
          {{ item.status_text }}</p>
        <p v-else-if="item.status_slug == 'active'"
          class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#73B7E5] capitalize">
          {{ item.status_text }}</p>
        <p v-else-if="item.status_slug == 'cancelled'"
          class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#D7385E] capitalize">
          {{ item.status_text }}</p>
          <p v-else-if="item.status_slug == 'payment_retry'"
          class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#448AFF] capitalize">
          {{ item.status_text }}</p>
        <p v-else>-</p>
      </div>
    </div>
    <div class="flex justify-between items-center border-b pb-2.5">
      <div class="w-1/2">
        <h6 class="mb-1 text-[14px] font-normal font-poppins text-customYellow-100">
          Purchase Date
        </h6>
        <h4 class="mb-0 text-[16px] font-normal font-poppins text-gray-900">
          {{ $helper.isEmpty(item.sales_date) ? '-' : $helper.formattedDate(item.sales_date) }}
        </h4>
      </div>
      <div class="w-1/2">
        <h6 class="mb-1 text-[14px] font-normal font-poppins text-customYellow-100">
          Activation Date
        </h6>
        <h4 class="mb-0 text-[16px] font-normal font-poppins text-gray-900">
          {{ $helper.isEmpty(item.activation_date) ? '-' : item.activation_date }}
        </h4>
      </div>
    </div>
    <div class="flex justify-between items-center border-b pb-2.5">
      <div class="w-1/2">
        <h6 class="mb-1 text-[14px] font-normal font-poppins text-customYellow-100">
          Next Payment Date
        </h6>
        <h4 class="mb-0 text-[16px] font-normal font-poppins text-gray-900">
          {{ $helper.isEmpty(item.next_charge_date) ? '-' : $helper.formattedDate(item.next_charge_date) }}
        </h4>
      </div>
      <div class="w-1/2">
        <h6 class="mb-1 text-[14px] font-normal font-poppins text-customYellow-100">
          Expiry Date
        </h6>
        <h4 class="mb-0 text-[16px] font-normal font-poppins text-gray-900">
          {{ $helper.isEmpty(item.expiry_date) ? '-' : item.expiry_date }}
        </h4>
      </div>
    </div>
    <div v-if="!$helper.isEmpty(item.cancelled_at) && item.cancelled_at != '-'" class="flex justify-between items-center border-b pb-2.5">
      <div class="w-1/2">
        <h6 class="mb-1 text-[14px] font-normal font-poppins text-customYellow-100">
          Cancelled At
        </h6>
        <h4 class="mb-0 text-[16px] font-normal font-poppins text-[#D7385E]">
          {{ $helper.formatDateTime(item.cancelled_at)}}
        </h4>
      </div>
    </div>
    <div class="flex justify-between items-center border-b pb-2.5">
      <div class="w-1/2">
        <h6 class="mb-1 text-[14px] font-normal font-poppins text-customYellow-100">
          Agreement ID
        </h6>
        <h4 class="mb-0 text-[16px] font-normal font-poppins text-gray-900">
          {{ $helper.isEmpty(item.agreement_id) ? '-' : item.agreement_id }}
        </h4>
      </div>
    </div>
    <div class="flex flex-col border-b pb-2.5">
      <h6 class="mb-1 text-[14px] font-normal font-poppins text-customYellow-100">
        Plan Name
      </h6>
      <h4 class="mb-0 text-[16px] font-normal font-poppins text-gray-900">
        {{ $helper.isEmpty(item.plan_name) ? '-' : item.plan_name }}
      </h4>
    </div>
    <div class="flex flex-col border-b pb-2">
      <h6 class="mb-0 text-[14px] font-normal font-roboto text-customYellow-100">
        Payment Method
      </h6>
      <h4 class="mb-0 text-[16px] font-normal font-roboto text-gray-900">
        {{ $helper.isEmpty(item.last_digits) ? '-' : `Credit Card - ${item.last_digits}` }}
      </h4>
      <p class="!mt-[5px] mb-0 text-[13px] font-poppins py-[5px] px-[10px] rounded-[5px] text-[#333] bg-[#E5D3B7]/25">This payment method will be used for recurring charges</p>
    </div>
    <div class="flex flex-col border-b pb-2.5">
      <h6 class="mb-1 text-[14px] font-normal font-poppins text-customYellow-100">
        Address
      </h6>
      <h4 class="!no-underline mb-0 text-[16px] font-normal font-poppins text-gray-900">
        {{ $helper.isEmpty(item.service_address) ? '-' : item.service_address }}
      </h4>
    </div>
    <div class="flex flex-col">
      <h6 class="mb-1 text-[14px] font-normal font-poppins text-customYellow-100">
        Billing Address
      </h6>
      <h4 class="!no-underline mb-0 text-[16px] font-normal font-poppins text-gray-900">
        {{ $helper.isEmpty(item.billing_address) ? '-' : item.billing_address }}
      </h4>
    </div>
  </div>
</template>


<script>


export default {

  components: {

  },

  props: ["item"],
  data() {
    return {

    };
  },
  computed: {

  },

  watch: {

  },

  mounted() {

  },

  methods: {
  },
};
</script>